import { useTranslation } from "react-i18next"

export default function HomeFooter() {
	const {t} = useTranslation()
  return(<>
		<div className="ast_faq_wrapper ast_toppadder70 ast_bottompadder70">
			<div className="container">
				<div className="row">
					<div className="col-lg-10 col-md-12 col-sm-12 col-12 offset-lg-1 offset-md-0 offset-sm-0 offset-0">
						<div className="ast_faq_section">
							<div className="accordion" id="accordionPanelsStayOpenExample">
							<div className="accordion-item">
								<h2 className="accordion-header" id="panelsStayOpen-headingOne">
										<button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">{t('faq.ask_1')}</button>
									</h2>
								<div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
								<div className="accordion-body">{t('faq.ask_1_response')}</div>
							</div>
							</div>
								<div className="accordion-item">
									<h2 className="accordion-header" id="panelsStayOpen-headingTwo">
										<button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">{t("faq.ask_2")}</button>
									</h2>
									<div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
										<div className="accordion-body">{t('faq.ask_2_response')}</div>
									</div>
								</div>
							</div>
						</div>
						</div>
					</div>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12">
						<div className="ast_copyright_wrapper">
							<p>&copy; Copyright 2022, All Rights Reserved, <a href="https://quantum-devs.xyz">Quantum Devs</a></p>				
						</div>			
					</div>	
			</div>
		</div>
  </>)
}